export const formulaireComponents = {
  SocioFormulaire: () => import("./SocioFormulaire.vue"),
  SocioFormulaireCategories: () => import("./SocioFormulaireCategories.vue"),
  SocioFormulaireQuestion: () => import("./SocioFormulaireQuestion.vue"),
  SocioFormulaireQuestionNode: () =>
    import("./SocioFormulaireQuestionNode.vue"),
  SocioFormulaireQuestionInput: () =>
    import("./SocioFormulaireQuestionInput.vue"),
  SocioFormulaireQuestionExtraData: () =>
    import("./SocioFormulaireQuestionExtraData.vue"),
};
